import apiHybris from '~/services/apiHybris';
import { GENERIC_ERROR_SIGNUP } from '~/utils/getFriendlyError';
import { getRawCellphone, getRawDocument } from '~/utils/string';

export async function createAccountUseCase(formData: CreateAccount.Form) {
  try {
    const { firstName, lastName, birthDate, cellphone, gender } =
      formData.personalInfo!;

    const rawCellphone = getRawCellphone(cellphone);

    const postData = {
      login: formData.email,
      firstName: firstName,
      lastName: lastName,
      password: formData.password,
      cpfCnpj: getRawDocument(formData.document ?? ''),
      typeCustomer: 'CUSTOMER',
      dddCellPhoneNumber: rawCellphone.slice(0, 2),
      cellPhoneNumber: rawCellphone.slice(2, 11),
      birthdate: birthDate,
      gender: gender,
    };

    await apiHybris.post('users', postData, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    });

    return true;
  } catch (error: any) {
    let message = error.message;
    if (
      error.response &&
      error.response?.status === 400 &&
      error.response.data
    ) {
      message = error.response.data.errors[0].message;
    }

    if (
      error.response &&
      error.response.data.errors[0].type === 'ModelSavingError'
    ) {
      message = GENERIC_ERROR_SIGNUP;
    }

    throw { message };
  }
}
